export default "__VITE_ASSET__31057cba__"